import React, { useEffect, useState, MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Paper,
  Table,
  TextField,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Popover,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import PaginationComponent from '../../../../components/Pagination';
import userProfile from '../../../../assets/images/userProfile.svg';
import { Status } from '../../../../components/index';
import { ReactComponent as SearchIcon } from '../../../../assets/images/Search.svg';
import useDebounce from '../../../../components/Debounce';
import rolemanagement from '../../../../assets/images/roleManagement_Inactive.svg';
import { useSelector } from 'react-redux';
import { useHook as UserManagementHook } from './useHook';
import { useHook as RoleHook } from '../../Iam/rolemanagement/useHook';
interface Role {
  roleID: string | number;
  roleName?: string;
}

interface Props {
  pagePermissionIDs: unknown;
}

interface UserDetails {
  firstName: string;
  lastName: string;
  email: string;
  status: string;
  roles: string[];
  userID: string;
  avatar: string;
}

interface Filter {
  roleIDs: string[];
}
const UserManagement: React.FC<Props> = ({ pagePermissionIDs }) => {
  const navigate = useNavigate();
  const { fetchGetAllRoleList } = RoleHook();
  const [search, setSearch] = useState<string>('');
  const debouncedSearch = useDebounce(search, 1000);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedRoles, setSelectedRoles] = useState<string[]>([]);
  const [filteredRoles, setFilteredRoles] = useState<Role[]>([]);
  const [userAnchorEl, setUserAnchorEl] = useState<null | HTMLElement>(null);
  const userOpen = Boolean(userAnchorEl);
  const userId = userOpen ? 'simple-popover' : undefined;
  const { allRole } = useSelector((state: any) => state.role);
  const { userList } = useSelector((state: any) => state.user);
  const { fetchUserList, fetchAllUserList } = UserManagementHook();
  const handleUserClose = () => {
    setUserAnchorEl(null);
  };
  const canCreateusers =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('users::create');

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    getData(page, rowsPerPage, search);
  };
  const handleUserClick = (event: MouseEvent<HTMLElement>): void => {
    setUserAnchorEl(event.currentTarget);
  };
  const handleRowsPerPageChange = (value: number) => {
    getData(currentPage - 1, value, search);
    setRowsPerPage(value);
    setCurrentPage(1);
  };

  const handleSearchChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const search = event.target.value;
    if (search !== '') {
      setSearch(search);
    } else {
      setSearch('');
    }
    if (!search) {
      getData(currentPage, rowsPerPage, search);
    }
  };

  useEffect(() => {
    getData();
  }, [selectedRoles]);

  const getUserData = async () => {
    await fetchAllUserList({});
  };

  useEffect(() => {
    if (!(allRole?.length > 0)) {
      fetchGetAllRoleList({});
    }
  }, []);

  const getData = async (
    pagenumber?: number,
    row_perpage?: number,
    search: unknown = '',
    filters: Filter[] | undefined = [],
    sort: { orderBy: string; order: number } = {
      orderBy: 'createdAt',
      order: -1,
    },
  ) => {
    // const setfilter = filters?.length > 0 ? { roles: filters } : {};
    const payload = {
      sort: sort,
      search: search,
      filters: { roles: selectedRoles?.length > 0 ? selectedRoles : null },
      limit: row_perpage ? row_perpage : rowsPerPage,
      offset: pagenumber
        ? (pagenumber - 1) * rowsPerPage
        : (currentPage - 1) * rowsPerPage,
    };
    await fetchUserList(payload).then((res: any) => {
      const totalPage = res?.count
        ? Math.ceil(res?.count / (row_perpage ? row_perpage : rowsPerPage))
        : 1;
      setTotalPages(totalPage);
    });
  };

  useEffect(() => {
    getData();
    getUserData();
  }, []);
  useEffect(() => {
    setFilteredRoles(allRole);
  }, [allRole]);
  const findrolename = (roleid: string) => {
    if (allRole?.length > 0) {
      if (roleid) {
        const findrole = allRole.find((param: Role) => param.roleID == roleid);
        return findrole?.roleName ? findrole?.roleName : roleid;
      } else {
        return roleid;
      }
    } else {
      return roleid;
    }
  };

  useEffect(() => {
    if (debouncedSearch) {
      getData(currentPage, rowsPerPage, search);
    }
  }, [debouncedSearch]);

  const handleRoleSelection = (roleName: string | undefined) => {
    if (!roleName) return;
    setSelectedRoles((prevSelectedRoles) => {
      if (prevSelectedRoles.includes(roleName)) {
        const updatedRoles = prevSelectedRoles.filter(
          (role) => role !== roleName,
        );
        return updatedRoles;
      } else {
        const updatedRoles = [...prevSelectedRoles, roleName];
        return updatedRoles;
      }
    });
  };

  const handleUserSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const query = event.target.value.toLowerCase();
    const filtered = allRole.filter((role: { roleName: string }) =>
      role.roleName?.toLowerCase().includes(query),
    );
    setFilteredRoles(filtered);
  };

  return (
    <>
      <div className="content  user_management">
        <div className=" d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3">
          <div className="d-flex justify-content-center align-items-center">
            <div>
              <Typography variant="h5" className="h5 table-header">
                <b>Users</b>
              </Typography>
              <Typography
                variant="body1"
                className="table-header-instruction m-0"
              >
                View and update your Users
              </Typography>
            </div>
            <div className="content  global_audilog user_management">
              <div className="global_audilog_header">
                <div className=" users_buttons_btn">
                  <Button
                    className="global_audilog_date-btn global_buttons"
                    aria-describedby={userId}
                    onClick={handleUserClick}
                  >
                    <img src={rolemanagement} width={24} alt="role img" />
                    <div className="typo_head">
                      {' '}
                      <Typography>Select Role</Typography>
                    </div>
                  </Button>
                </div>
                <Popover
                  className="popover-audits"
                  id={userId}
                  open={userOpen}
                  anchorEl={userAnchorEl}
                  onClose={handleUserClose}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                  }}
                >
                  <div className="user_name-popover">
                    <div className="user_name-popover-search">
                      <TextField
                        className="user_name-popover-search_input search-input"
                        variant="outlined"
                        placeholder="Search user names here"
                        fullWidth
                        InputProps={{
                          startAdornment: (
                            <SearchIcon className="search_icon" />
                          ),
                        }}
                        onChange={handleUserSearch}
                      />
                    </div>
                    <div>
                      {filteredRoles.map((role, index) => (
                        <div
                          key={index}
                          className={
                            selectedRoles.includes(String(role.roleID))
                              ? 'role-popover-checkbox role-popover-checkbox_active'
                              : 'role-popover-checkbox'
                          }
                        >
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={selectedRoles.includes(
                                  String(role.roleID),
                                )}
                                onChange={() => {
                                  handleRoleSelection(String(role.roleID));
                                }}
                              />
                            }
                            label={role.roleName}
                          />
                          {/* <div className="global_audilog_user_profile">
                            <p>{role.roleName}</p>
                          </div>
                          {selectedRoles.includes(String(role.roleID)) && (
                            <IconButton className="iconButton">
                              <DoneIcon className="doneIcon" />
                            </IconButton>
                          )} */}
                        </div>
                      ))}
                    </div>
                  </div>
                </Popover>
              </div>
            </div>
          </div>
          <div className="table-header-btn">
            <TextField
              variant="outlined"
              placeholder="Search"
              onChange={handleSearchChange}
              InputProps={{
                startAdornment: <SearchIcon />,
              }}
              className="search-input"
            />
            {canCreateusers && (
              <Button
                className="create-btn"
                color="primary"
                onClick={() => navigate('/iam/user/create')}
              >
                Create user
              </Button>
            )}
          </div>
        </div>

        <TableContainer
          className="user_management_table-container"
          component={Paper}
        >
          <Table>
            <TableHead className="user_management_table-heading">
              <TableRow>
                <TableCell className="user_management_name">Names</TableCell>
                <TableCell className="user_management_status">Status</TableCell>
                <TableCell className="user_management_roles">Roles</TableCell>
                <TableCell className="user_management_icon"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {!userList ||
              userList?.length === 0 ||
              userList?.filter(
                (user: { roles: string[] }) =>
                  !selectedRoles.length ||
                  (user.roles &&
                    user.roles.some((role: string) =>
                      selectedRoles.includes(role),
                    )),
              ).length === 0 ? (
                <TableRow>
                  <TableCell colSpan={2}>
                    <Typography variant="body1" align="left">
                      No Data found
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                userList
                  ?.filter(
                    (user: { roles: any[] }) =>
                      !selectedRoles.length ||
                      (user.roles &&
                        user.roles.some((role: string) =>
                          selectedRoles.includes(role),
                        )),
                  )
                  .map((user: UserDetails, index: number) => (
                    <TableRow key={index}>
                      <TableCell>
                        <div className="user_management_name-data">
                          <img
                            src={user?.avatar ? user?.avatar : userProfile}
                            width={24}
                            alt="User Profile"
                          />{' '}
                          <Typography variant="body1">
                            {user.firstName + ' ' + user.lastName}
                          </Typography>
                        </div>
                      </TableCell>
                      <TableCell>
                        <Status status={user.status} />
                      </TableCell>
                      <TableCell>
                        {user.roles &&
                          user.roles.map((role: string, index: number) => (
                            <div
                              key={index}
                              className="user_management_roles-data"
                            >
                              <Typography variant="body1">
                                {findrolename(role)}
                              </Typography>
                            </div>
                          ))}
                      </TableCell>
                      <TableCell>
                        <div className="user_management_icon-data">
                          <Button
                            className="btn-transparent border-0 img-background-form"
                            onClick={() =>
                              navigate(
                                `/iam/user/edit/${user.firstName + user.lastName}/${user.userID}`,
                                { state: { user } },
                              )
                            }
                          >
                            <i className="edit-icon bi bi-pencil-square bi-lg"></i>
                          </Button>
                        </div>
                      </TableCell>
                    </TableRow>
                  ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {userList && userList?.length ? (
          <PaginationComponent
            rowsPerPageOptions={[5, 10, 20, 30]}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
            totalPages={totalPages}
          />
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default UserManagement;
